module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/truckFeatured1.webp";